export default "__VITE_ASSET__Pi36fDX4__"